// extracted by mini-css-extract-plugin
export default {"main":"styles_main__IMvBZ","carousel":"styles_carousel__q56ch","slide":"styles_slide__j8UpC","dots_container":"styles_dots_container__OovNk","dots":"styles_dots__fyoAd"};